import topic from "common/managers/topic";
import locale from "common/managers/locale";
import confirmation from "app/main/confirmation/Confirmation";
import loginProps from "common/managers/loginProps";
export default kendo.data.ObservableObject.extend({

    //The message to display
    message: undefined,

    //Datasource for the stack trace window
    stackDS: new kendo.data.DataSource({
        data: []
    }),

    //Can the stack trace window be shown
    stackShow: undefined,

    //Error code of error
    code: "",

    //Server message to display
    serverMessage: "",

    //Main error window open state
    windowOpen: false,

    //Stack trace window open state
    stackOpen: false,

    //Queue of errors to display
    _errors: [],

    /**
     * Open a window if necessary to display an error.
     * @private
     */
    _open: function() {
        if (!this.get("stackOpen") && !this.get("windowOpen") && this._errors.length > 0) {
            var error = this._errors.pop();
            this.set("stackShow", error.stack.length > 0);
            this.get("stackDS").data(error.stack);
            this.set("message", error.message);
            this.set("code", error.code);
            this.set("serverMessage", error.serverMessage);
            this.set("windowOpen", true);
        }
    },

    //Show the stack trace window
    showStackNow: function(e) {
        e.preventDefault();
        this.set("stackOpen", true);
        this.set("windowOpen", false);
    },

    /**
     * Handle change.
     * @private
     */
    _onChange: function(e) {
        if (e.field == "stackOpen" || e.field == "windowOpen" || e.field == "_errors") {
            this._open();
        }
    },

    //Handler for error/server
    errorServer: function(err) {
        var stack = err.get("stackTrace");
        this._errors.push({
            stack: stack ? stack : [],
            message: locale.get("error.unknown", err.get("statusCode"), err.get("type")),
            code: false,
            serverMessage: $("<div></div>").html(err.get("message")).text()
        });
    },

    //Handler for error/message
    errorMessage: function(err) {
        this._errors.push({
            stack: [],
            message: err.get("message"),
            code: err.get("localeErrorCode"),
            serverMessage: ""
        });
    },

    //Handler for error/malformed
    errorMalformed: function(err) {
        this._errors.push({
            stack: [],
            message: locale.get("error.malformed", err.status),
            code: "",
            serverMessage: ""
        });
    },

    //Handler for error/timeout
    errorTimeout: function() {
        if (loginProps.get().serverUnavailableDialog) {
            this._errors.push({
                stack: [],
                title: locale.get("error.title"),
                message: locale.get("error.timeout"),
                code: "",
                serverMessage: ""
            });
        }
    },

    //Handler for error/client
    errorClient: function(err) {
        this._errors.push({
            stack: [],
            message: err.get("message") || locale.get("error.javascript"),
            code: "",
            serverMessage: ""
        });
    },

    init: function() {
        kendo.data.ObservableObject.fn.init.apply(this, arguments);
        this.set("_errors", []);
        this.bind("change", this._onChange);
    }
});
